export enum LocalStorageKeys {
    Jwt = 'jwt',
    User = 'user',
    TableColumns = 'table-columns',
    ShipmentsTableColumns = 'shipments-table-columns',
    ShipmentsPlanFactComparisonColumns = 'shipments-plan-fact-comparison-columns',
    DesignerTasksScale = 'designer-tasks-scale',
}
